// import React, { useState, useEffect } from "react";
// import { db } from "../../firebase";
// import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

// const PriceConfigure = () => {
//   const docRef = doc(db, "admin", "priceconfigure");

//   const [singlePrintPrice, setSinglePrintPrice] = useState("");
//   const [bulkOrderPrice, setBulkOrderPrice] = useState("");
//   const [currentPrices, setCurrentPrices] = useState({
//     singlePrint: "",
//     bulkOrder: "",
//   });

//   const [coupon, setCoupon] = useState({
//     id: "",
//     name: "",
//     number: "",
//     value: "",
//     startDate: "",
//     expiryDate: "",
//   });
//   const [coupons, setCoupons] = useState([]);
//   const [showForm, setShowForm] = useState(false);

//   // Fetch data from Firestore
//   const fetchData = async () => {
//     try {
//       const docSnap = await getDoc(docRef);
//       if (docSnap.exists()) {
//         const data = docSnap.data();
//         setCurrentPrices(data.prices || {});
//         setCoupons(data.coupons || []);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   // Save prices
//   const savePrice = async (type) => {
//     try {
//       const updatedPrices = {
//         ...currentPrices,
//         [type]: type === "singlePrint" ? singlePrintPrice : bulkOrderPrice,
//       };
//       await setDoc(docRef, { prices: updatedPrices }, { merge: true });
//       fetchData();
//     } catch (error) {
//       console.error("Error saving price:", error);
//     }
//   };

//   // Save coupon
//   const saveCoupon = async () => {
//     try {
//       const updatedCoupons = [...coupons, coupon];
//       await updateDoc(docRef, { coupons: updatedCoupons });
//       setCoupon({
//         id: "",
//         name: "",
//         number: "",
//         value: "",
//         startDate: "",
//         expiryDate: "",
//       });
//       fetchData();
//     } catch (error) {
//       console.error("Error saving coupon:", error);
//     }
//   };

//   // Delete coupon
//   const deleteCoupon = async (index) => {
//     try {
//       const updatedCoupons = [...coupons];
//       updatedCoupons.splice(index, 1);
//       await updateDoc(docRef, { coupons: updatedCoupons });
//       fetchData();
//     } catch (error) {
//       console.error("Error deleting coupon:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   return (
//     <div className="container py-4">
//       <h2 className="mb-4 text-center">Price & Coupon Configuration</h2>

//       {/* Single Order Price */}
//       <div className="card shadow-sm">
//         <div className="card-body d-flex flex-row gap-2 align-middle">
//           <h5 className="card-title mt-1">Agent Self Printing Price :</h5>
//           {/* <div className="row g-2 align-items-center"> */}
//           <div className="col-md- d-flex flex-row gap-2">
//             <input
//               type="number"
//               className="form-control w-50 ms-3"
//               style={{ height: "35px" }}
//               placeholder="Enter single print price"
//               value={singlePrintPrice}
//               onChange={(e) => setSinglePrintPrice(e.target.value)}
//             />
//             {/* </div> */}
//             <div className="col-md-2">
//               <button
//                 className="btn btn-primary"
//                 onClick={() => savePrice("singlePrint")}
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//           <p className=" text-muted">
//             Current Price:{" "}
//             <strong>{currentPrices.singlePrint || "Not set"}</strong>
//           </p>
//         </div>

//         <div className="card-body d-flex flex-row gap-2 align-middle">
//           <h5 className="card-title mt-2">Company Order Print Price :</h5>
//           <div className="row g-2 align-items-center">
//             <div className="col-md-6">
//               <input
//                 type="number"
//                 style={{ height: "35px" }}
//                 className="form-control"
//                 placeholder="Enter bulk order price"
//                 value={bulkOrderPrice}
//                 onChange={(e) => setBulkOrderPrice(e.target.value)}
//               />
//             </div>
//             <div className="col-md-2">
//               <button
//                 className="btn btn-primary"
//                 onClick={() => savePrice("bulkOrder")}
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//           <p className="text-muted">
//             Current Price:{" "}
//             <strong>{currentPrices.bulkOrder || "Not set"}</strong>
//           </p>
//         </div>
//       </div>

//       {/* Bulk Order Price */}
//       <div className="card mb-4 shadow-sm"></div>

//       {/* Coupon Management */}
//       <div className="card shadow-sm">
//         <div className="card-body">
//           <h6 className="mt-4">Coupons List</h6>
//           <ul className="list-group">
//             {coupons.map((c, index) => (
//               <li
//                 key={index}
//                 className="list-group-item d-flex justify-content-between align-items-center"
//               >
//                 <div>
//                   <table className="table table-bordered table-striped">
//                     <thead className="table-dark w-75">
//                       <tr>
//                         <th>Card Name</th>
//                         <th>Card ID</th>
//                         <th>Card Value</th>
//                         <th>Card Start Date</th>
//                         <th>Card Expire Date</th>
//                       </tr>
//                     </thead>
//                     <tr>
//                       <td>{c.name}</td>
//                       <td>{c.id}</td>
//                       <td>{c.value}</td>
//                       <td>{c.startDate}</td>
//                       <td>{c.expiryDate}</td>
//                     </tr>
//                   </table>
//                   {/* <strong>{c.name}</strong> (ID: {c.id}, Value: {c.value})<br />
//                   Valid: {c.startDate} to {c.expiryDate} */}
//                 </div>
//                 <button
//                   className="btn btn-sm btn-danger"
//                   onClick={() => deleteCoupon(index)}
//                 >
//                   Delete
//                 </button>
//               </li>
//             ))}
//           </ul>
//           <h5 className="card-title mt-5">Add Coupon</h5>
//           <div className="row g-2">
//             {["id", "name", "number", "value"].map((field) => (
//               <div className="col-md-6" key={field}>
//                 <input
//                   type={field === "value" ? "number" : "text"}
//                   className="form-control"
//                   placeholder={`Coupon ${field}`}
//                   value={coupon[field]}
//                   onChange={(e) =>
//                     setCoupon({ ...coupon, [field]: e.target.value })
//                   }
//                 />
//               </div>
//             ))}
//             <div className="col-md-6">
//               <input
//                 type="date"
//                 className="form-control"
//                 value={coupon.startDate}
//                 onChange={(e) =>
//                   setCoupon({ ...coupon, startDate: e.target.value })
//                 }
//               />
//             </div>
//             <div className="col-md-6">
//               <input
//                 type="date"
//                 className="form-control"
//                 value={coupon.expiryDate}
//                 onChange={(e) =>
//                   setCoupon({ ...coupon, expiryDate: e.target.value })
//                 }
//               />
//             </div>
//             <div className="col-12">
//               <button className="btn btn-success w-100" onClick={saveCoupon}>
//                 Save Coupon
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PriceConfigure;

import React, { useEffect, useState } from "react";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase"; // adjust path as needed
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const PriceConfigure = () => {
  const docRef = doc(db, "admin", "priceconfigure");

  const [singlePrintPrice, setSinglePrintPrice] = useState("");
  const [bulkOrderPrice, setBulkOrderPrice] = useState("");
  const [currentPrices, setCurrentPrices] = useState({
    singlePrint: "",
    bulkOrder: "",
  });

  const [coupon, setCoupon] = useState({
    id: "",
    name: "",
    number: "",
    value: "",
    startDate: "",
    expiryDate: "",
  });
  const [coupons, setCoupons] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchData = async () => {
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setCurrentPrices(data.prices || {});
        setCoupons(data.coupons || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleOpenModal = () => {
    setCoupon({
      id: generateAccountId(),
      name: "",
      number: "",
      value: "",
      startDate: "",
      expiryDate: "",
    });
    setShowModal(true);
  };

  const savePrice = async (type) => {
    try {
      const updatedPrices = {
        ...currentPrices,
        [type]: type === "singlePrint" ? singlePrintPrice : bulkOrderPrice,
      };
      await setDoc(docRef, { prices: updatedPrices }, { merge: true });
      fetchData();
    } catch (error) {
      console.error("Error saving price:", error);
    }
  };

  const generateAccountId = () =>
    Math.floor(11111111 + Math.random() * 99999999).toString();
  const couponId = generateAccountId;

  const saveCoupon = async () => {
    try {
      const updatedCoupons = [...coupons, coupon];
      await updateDoc(docRef, { coupons: updatedCoupons });
      setCoupon({
        id: "",
        name: "",
        number: "",
        value: "",
        startDate: "",
        expiryDate: "",
      });
      setShowModal(false);
      fetchData();
    } catch (error) {
      console.error("Error saving coupon:", error);
    }
  };

  const deleteCoupon = async (index) => {
    try {
      const updatedCoupons = [...coupons];
      updatedCoupons.splice(index, 1);
      await updateDoc(docRef, { coupons: updatedCoupons });
      fetchData();
    } catch (error) {
      console.error("Error deleting coupon:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-center">Price & Coupon Configuration</h2>

      {/* Price Configuration */}
      <div className="card shadow-sm mb-4 ">
        <div className="card-body">
          <div className="d-flex flex-row justify-content-center gap-3">
            <h5>Agent Self Printing Price</h5>
            <input
              type="number"
              className="form-control mb-2 w-25"
              placeholder="Enter single print price"
              value={singlePrintPrice}
              onChange={(e) => setSinglePrintPrice(e.target.value)}
            />
            <button
              className="btn btn-primary mb-3"
              onClick={() => savePrice("singlePrint")}
            >
              Save
            </button>
            <p>
              Current Price:{" "}
              <strong>{currentPrices.singlePrint || "Not set"}</strong>
            </p>
          </div>

          <div className="d-flex flex-row justify-content-center gap-3">
            <h5>Company Order Print Price</h5>
            <input
              type="number"
              className="form-control mb-3 w-25"
              placeholder="Enter bulk order price"
              value={bulkOrderPrice}
              onChange={(e) => setBulkOrderPrice(e.target.value)}
            />
            <button
              className="btn btn-primary mb-3"
              onClick={() => savePrice("bulkOrder")}
            >
              Save
            </button>
            <p>
              Current Price:{" "}
              <strong>{currentPrices.bulkOrder || "Not set"}</strong>
            </p>
          </div>
        </div>
      </div>

      {/* Coupon Management */}
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>Coupons List</h5>
            <button className="btn btn-success" onClick={handleOpenModal}>
              Add Coupon
            </button>
          </div>

          {coupons.length > 0 ? (
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  <th>Name</th>
                  <th>ID</th>
                  <th>Number</th>
                  <th>Value</th>
                  <th>Start Date</th>
                  <th>Expiry Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {coupons.map((c, index) => (
                  <tr key={index}>
                    <td>{c.name}</td>
                    <td>{c.id}</td>
                    <td>{c.number}</td>
                    <td>{c.value}</td>
                    <td>{c.startDate}</td>
                    <td>{c.expiryDate}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => deleteCoupon(index)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No coupons available.</p>
          )}
        </div>
      </div>

      {/* Modal for Adding Coupon */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Coupon</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {["id", "name", "number", "value"].map((field) => (
            <input
              key={field}
              type={field === "value" ? "number" : "text"}
              className="form-control mb-2"
              placeholder={`Coupon ${field}`}
              value={coupon[field]}
              onChange={(e) =>
                setCoupon({ ...coupon, [field]: e.target.value })
              }
            />
          ))}
          <input
            type="date"
            className="form-control mb-2"
            value={coupon.startDate}
            onChange={(e) =>
              setCoupon({ ...coupon, startDate: e.target.value })
            }
          />
          <input
            type="date"
            className="form-control mb-2"
            value={coupon.expiryDate}
            onChange={(e) =>
              setCoupon({ ...coupon, expiryDate: e.target.value })
            }
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={saveCoupon}>
            Save Coupon
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PriceConfigure;
